import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=e81e2d68&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=js&"
export * from "./AddressList.vue?vue&type=script&lang=js&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=e81e2d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81e2d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e81e2d68')) {
      api.createRecord('e81e2d68', component.options)
    } else {
      api.reload('e81e2d68', component.options)
    }
    module.hot.accept("./AddressList.vue?vue&type=template&id=e81e2d68&scoped=true&", function () {
      api.rerender('e81e2d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/AddressList.vue"
export default component.exports